import React, { useEffect, useState } from "react";
import $ from "jquery";

const Checkinpopup = (props) => {
  const [showNextBtn, setShowNextBtn] = useState(false);
  const submit = (e) => {
    $("body").css("overflow", "auto");
    props.nextpage("uploadview");
    // SaveState();
  };

  

  return (
    <>
      <div className="checkinpopup_bg">
        <div className="checkinpopup_content">
          <img
            onClick={() => props.close()}
            src="/assets/images/crosspopup.svg"
            className="close_check"
            alt=""
          />
          <div className="checkinpopup_inner">
            <ul className="swatch_list">
              <li>
                <img src="/assets/images/swatchbharat.png" alt="" />
              </li>
              <li>
                <h5>{props.data.beniname}</h5>
              </li>
            </ul>

            <ul className="check_list">
              <li>
                {/* <img src="/assets/images/check.svg" alt="" /> */}
                <label className="containercheck">
                  <input
                    value={showNextBtn}
                    onChange={() => setShowNextBtn(!showNextBtn)}
                    type="checkbox"
                    name=""
                    id=""
                  />{" "}
                  Please verify your current location on the map to proceed
                  <span className="checkmark"></span>
                </label>
                {/* <input
                  value={showNextBtn}
                  onChange={() => setShowNextBtn(!showNextBtn)}
                  type="checkbox"
                  name=""
                  id=""
                /> */}
              </li>
              {/* <li>
                <h5>
                  Please verify your current location on the map to proceed
                </h5>
              </li> */}
            </ul>
            {/* <img src="/assets/images/map.jpg" className="map_img" alt="" /> */}
            <iframe
              src={`https://maps.google.com/maps?q=${props.data.lat},${props.data.long}&output=embed&disable=1`}
              class="iframe_map"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="google map"
            ></iframe>

          
            {showNextBtn && (
              <div className="next_btn checkin_btn">
                <a
                  href="#"
                  onClick={() => {
                    submit();
                  }}
                >
                  Next
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default Checkinpopup;
